
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delta-max-portable-power-station",
      function () {
        return require("private-next-pages/delta-max-portable-power-station/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delta-max-portable-power-station"])
      });
    }
  